import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'atw-vh-virtual-position-config',
  templateUrl: './vh-virtual-position-config.component.html',
  styleUrls: ['./vh-virtual-position-config.component.scss']
})
export class VhVirtualPositionConfigComponent implements OnInit {
  @Input() id_parent_choose;
  @Input() array_object_selected;
  @Input() selectedDevice;
  constructor() { }

  ngOnInit() {
  }

}
